export default "__VITE_ASSET__CHL$v$vq__"